// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"40ec0b7d","658":"c3b7f9b3","677":"d9bb7f98","778":"73dc8396"}[chunkId] + ".chunk.js";
};